'use client';

import { FunctionComponent } from 'react';
import Company from '@business/general/Company';
import ALink from '@xFrame4/components/next/ALink';
import SocialMediaLinks from '@components/common/SocialMediaLinks';
import AppTracker from '@components/tracking/AppTracker';

export interface FooterCompanyInfoProps
{
    language: string;
    company: Company;
}

/**
 * Component: Footer company information section with contact details and social media links.
 */
const FooterCompanyInfo: FunctionComponent<FooterCompanyInfoProps> = (props) =>
{
    const company = Company.createFromJson(props.company) as Company;
    const companyTranslation = company.getTranslation(props.language);

    /** Render */
    return (
        <div className="footer-company-info">
            <h4 className="h4 text-white text-uppercase mb-3">{companyTranslation?.name}</h4>
            <div className="footer-contact-info">
                <div className="mb-3">
                    <i className="fas fa-map-marker-alt me-2"></i>
                    <ALink
                        href={`https://maps.app.goo.gl/ZdUZhuF2otVFGePe9`}
                        className="text-white text-decoration-none"
                        target="_blank"
                        onClick={() => AppTracker.trackAddressClick()}
                    >
                        <span>
                            {companyTranslation?.addressLine1}
                            {companyTranslation?.addressLine2 &&
                                <span>, {companyTranslation.addressLine2}</span>
                            }
                            {companyTranslation?.cityName &&
                                <span>, {companyTranslation.cityName}</span>
                            }
                            {props.company.postalCode &&
                                <span>, {props.company.postalCode}</span>
                            }
                        </span>
                    </ALink>
                </div>
                <div className="mb-3">
                    <i className="fas fa-phone me-2"></i>
                    <ALink href={`tel:${props.company.phone}`} className="text-white text-decoration-none" onClick={() => AppTracker.trackPhoneClick()}>
                        {props.company.phone}
                    </ALink>
                </div>
                <div className="mb-3">
                    <i className="fas fa-envelope me-2"></i>
                    <ALink href={`mailto:${props.company.email}`} className="text-white text-decoration-none" onClick={() => AppTracker.trackEmailClick()}>
                        {props.company.email}
                    </ALink>
                </div>
                <div className="mb-3 social-media-links">
                    <SocialMediaLinks
                        facebook={companyTranslation?.socialMediaFacebook}
                        instagram={companyTranslation?.socialMediaInstagram}
                        linkedin={companyTranslation?.socialMediaLinkedin}
                        youtube={companyTranslation?.socialMediaYoutube}
                        tiktok={companyTranslation?.socialMediaTiktok}
                        linkClassName="text-white text-decoration-none"
                    />
                </div>
            </div>
        </div>
    );
}

export default FooterCompanyInfo; 